export default __webpack_public_path__ + "static/media/linkedin.945d23af.svg";